import * as wjcCore from '@grapecity/wijmo';
import * as wjcGrid from '@grapecity/wijmo.grid';

'use strict';

import {ViewChild, Component, OnInit} from '@angular/core';
import {FormGroup, FormControl, Validators, FormBuilder} from "@angular/forms";
import {PasswordValidators} from "ng2-validators";
import {ToasterService} from "angular2-toaster";

import {KaitoriyaConfig} from "../config/kaitoriya.config";
import {FormHelperService} from "../services/form-helper.service";
import {DataService} from "@cosbeni/database";
import {OrientDBCollectionView} from "@cosbeni/database";
import {ORole, OUser} from "@cosbeni/database";


@Component({
    selector: 'cj-admin-user',
    templateUrl: 'user-management.component.html'
})

export class UserManagementComponent implements OnInit {
    createForm: FormGroup;
    editForm: FormGroup;
    passwordForm: FormGroup;
    readonly: Boolean = true;
    @ViewChild('grid') grid: wjcGrid.FlexGrid;
    users: OrientDBCollectionView;
    roles: ORole[];
    role: ORole;
    user: any = new OUser();
    password: string = '';
    mode: string = "view";

    constructor(public dataService: DataService, public toasterService: ToasterService, public formHelper: FormHelperService, public formBuilder: FormBuilder) {
        this.users = new OrientDBCollectionView(dataService, KaitoriyaConfig.DATABASE, "SELECT FROM OUser", "OUser", "", 0, 100, true, true, false)
        this.users.url = KaitoriyaConfig.SERVER_URL;
        this.users.tokenName = KaitoriyaConfig.DATABASE + "_token";
        this.users.filterOnServer = true;
    }

    ngOnInit() {
        this.users.currentChanged.addHandler(this.onCurrentChanged, this);
        this.createForm = this.formBuilder.group({
            username: new FormControl('', [Validators.required, Validators.minLength(3)]),
            password: new FormGroup({
                newPassword: new FormControl('', [Validators.required, Validators.minLength(3)]),
                confirmPassword: new FormControl('', [])
            }, PasswordValidators.mismatchedPasswords())
        })
        this.editForm = this.formBuilder.group({
            username: new FormControl('', [Validators.required, Validators.minLength(3)])
        })
        this.passwordForm = this.formBuilder.group({
            password: new FormGroup({
                newPassword: new FormControl('', [Validators.required, Validators.minLength(3)]),
                confirmPassword: new FormControl('', [])
            }, PasswordValidators.mismatchedPasswords())
        })
        this.dataService.query({sql: "SELECT FROM ORole", count: "SELECT FROM ORole"}, KaitoriyaConfig.SERVER_URL).subscribe(response => {
            this.roles = response.results;
            for (let role of this.roles) {
                if (role.name == 'writer')
                    this.role = role;
            }
        })
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
        if (this.users.currentItem != null) {
            this.editForm.reset();
            this.user = Object.assign({}, this.users.currentItem);
        }
    }

    editUser(): void {
        this.mode = "edit"
    }

    confirmUser(): void {
        this.mode = "confirm"
    }

    createUser(): void {
        this.mode = "edit"
        this.user = new OUser();
        this.user.roles.push(this.role);
        console.log(this.role);
    }

    saveUser(): void {
        this.dataService.update([this.user], KaitoriyaConfig.SERVER_URL).subscribe((response: any) => {
            this.mode = "view";
            this.toasterService.pop('info', '保存', '保存されました。');
            this.users.queryData();
        }, (error: any) => {
            this.toasterService.pop('error', '保存', '失敗しました。');
        })
    }

    changePassword(): void {
        let command = "UPDATE  " + this.user['@rid'] + " SET password = '" + this.password + "'";
        this.dataService.command({sql: command}, KaitoriyaConfig.SERVER_URL).subscribe((response: any) => {
            this.mode = "view";
            this.toasterService.pop('info', 'パスワード変更', '変更されました。');
            this.users.queryData();
        }, (error: any) => {
            this.toasterService.pop('error', 'パスワード変更', '失敗しました。');
        })
    }

}

